import ApiIcon from '@mui/icons-material/Api';
import { Cloud } from '@mui/icons-material';
import GroupIcon from '@mui/icons-material/Group';
import CategoryIcon from '@mui/icons-material/Category';
import HandshakeIcon from '@mui/icons-material/Handshake';
import SettingsIcon from '@mui/icons-material/Settings';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import DashboardIcon from '@mui/icons-material/Dashboard';
import InventoryIcon from '@mui/icons-material/Inventory';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import LocalGroceryStoreIcon from '@mui/icons-material/LocalGroceryStore';

import Iconify from '../../media/iconify';

// ----------------------------------------------------------------------

/**
 * Centralized MUI icon map shared across all nav-item variants
 * (vertical, mini, horizontal).
 *
 * Keys are the string identifiers used in the nav config.
 * To add a new MUI icon: import it above and add an entry here.
 * For Iconify icons, no changes are needed — resolveNavIcon handles them automatically.
 */
export const muiIcons: Record<string, React.ReactNode> = {
  api: <ApiIcon />,
  cloud: <Cloud />,
  graph: <AutoGraphIcon />,
  group: <GroupIcon />,
  category: <CategoryIcon />,
  reports: <RequestQuoteIcon />,
  settings: <SettingsIcon />,
  handshake: <HandshakeIcon />,
  localstore: <LocalGroceryStoreIcon />,
  dashboard: <DashboardIcon />,
  inventory: <InventoryIcon />,
  resources: <BusinessCenterIcon />,
  attachMoney: <AttachMoneyIcon />,
  changeCircle: <ChangeCircleIcon />,
  accountCircle: <AccountCircleIcon />,
};

/**
 * Resolves a nav icon string to a React node.
 *
 * Resolution order:
 *  1. Looks up the key in `muiIcons` — returns the MUI icon element if found.
 *  2. Falls back to `<Iconify icon={icon} />` to support any Iconify icon string.
 */
export function resolveNavIcon(icon: string): React.ReactNode {
  if (muiIcons[icon]) return muiIcons[icon];
  return <Iconify icon={icon} />;
}
